import downloadFile from './downloadFile';

const downloadCsv = (csvContent, filename) => {
  downloadFile(csvContent, filename, 'text/csv;charset=utf-8;');
};

export default downloadCsv;
